/* eslint-disable no-undef */
import React, {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  Tooltip,

  // Divider,
  // Chip,
  IconButton,
  Switch,
  FormControlLabel,
  FormGroup,
  Checkbox,
  RadioGroup,
  Radio,
  FormLabel,
  TextField,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
} from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PropTypes from 'prop-types';
import { useThemeContext } from '../Context/ThemeContext';
import { toast } from 'react-toastify';
import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LaunchIcon from '@mui/icons-material/Launch';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useLocation } from 'react-router-dom';
import {
  fetchWorkflowRunStatus,
  triggerExecuteWorkflow,
  triggerCancelWorkflow,
  fetchScheduledStatus,
  cancelWorkflowSchedule,
} from '../apis/Workflows';

import { useDispatch, useSelector } from 'react-redux';
import {
  saveWorkflow,
  setScheduleDateTime,
  setScheduledStatus,
  setTriggerResponse,
  setScheduleLockUntil,
} from '../state/slices/workflowSlice';
import StatusTable from './StatusTable';
import { motion } from 'framer-motion';
import { setBlinkByWorkflow } from '../state/slices/mappingSlice';
import LogsViewer, { SimpleLogsViewer } from './LogsViewer';
import RunStatusTables from './RunStatusTable';
import { sendNotification } from '../apis/email';
import Cookies from 'js-cookie';
import ScheduledStatusTable from './ScheduledStatusTable';

//  {

function ActionButtonsInner(props, ref) {
  const {
    selectedNode,
    workflowId,
    workflowConfigurationId,
    onWorkflowExecutionComplete,
    onSave,
    collapsedBoth,
    onCollapsedChange,
    leftSidebarRef,
    rightSidebarRef,
  } = props;
  const dispatch = useDispatch();
  const workflowsObj = useSelector((state) => state.workflows.workflows || {});
  const workflowData = workflowsObj[workflowId];
  const workflowRunId = workflowData?.workflowRunId;
  const timezone = workflowData?.timezone;
  const scheduleLockUntil = workflowData?.scheduleLockUntil;
  const isScheduleLocked =
    Boolean(scheduleLockUntil) && dayjs(scheduleLockUntil).isAfter(dayjs());
  const scheduledStatus = workflowData?.scheduledStatus;

  const hasUnsavedChanges = useSelector(
    (state) => state.workflows?.unsavedChangesByWorkflow?.[workflowId],
  );

  const mustSaveBeforeAction =
    Boolean(hasUnsavedChanges) || !workflowConfigurationId;

  console.log('rightSidebarRef:', rightSidebarRef);
  console.log('leftSidebarRef:', leftSidebarRef);

  const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [frequency, setFrequency] = useState('');
  const [endDate, setEndDate] = useState(null);
  const [recurrenceEnabled, setRecurrenceEnabled] = useState(true);
  const [customDays, setCustomDays] = useState([]);
  const [hourInterval, setHourInterval] = useState(1);
  const { darkMode } = useThemeContext();
  const location = useLocation();

  const [executing, setExecuting] = useState(false);
  const [runStatus, setRunStatus] = useState(null);
  //eslint-disable-next-line
  const [isPolling, setIsPolling] = useState(false);
  const pollingRef = React.useRef(null);
  const scheduledPollingRef = React.useRef(null);
  const postPollTimeoutRef = useRef(null);
  const followUpCountRef = useRef(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [logsDialogOpen, setLogsDialogOpen] = useState(false);
  const [simpleLogsDialogOpen, setSimpleLogsDialogOpen] = useState(false);
  const triggerData = useSelector(
    (state) => state.workflows?.workflows?.[workflowId]?.triggerResponse,
  );

  const [shouldSaveAfterSchedule, setShouldSaveAfterSchedule] = useState(false);

  const executeBlink = useSelector(
    (state) => state.mapping.blinkByWorkflow?.[workflowId]?.execute,
  );

  console.log('triggerData', triggerData);

  const statusRef = useRef(null);
  const scrolledRunRef = useRef(null);
  const previousSuccessCountsRef = useRef({});

  const scheduleDisabled =
    isScheduleLocked ||
    mustSaveBeforeAction ||
    scheduledStatus?.status === 'SCHEDULED' ||
    runStatus?.status === 'ACTIVE';

  const scheduleTooltip = (() => {
    if (mustSaveBeforeAction) {
      return workflowConfigurationId
        ? 'Please save your latest changes before scheduling.'
        : 'Please save the workflow before scheduling.';
    }
    if (isScheduleLocked) {
      return "Cannot reschedule until the current workflow's end date";
    }
    if (scheduledStatus?.status === 'SCHEDULED') {
      return 'Workflow is already scheduled.';
    }
    if (runStatus?.status === 'ACTIVE') {
      return 'Workflow execution is currently active.';
    }
    return null;
  })();

  const executeDisabled =
    mustSaveBeforeAction ||
    executing ||
    runStatus?.status === 'ACTIVE' ||
    runStatus?.status === 'PROCESSING';

  const executeTooltip = (() => {
    if (mustSaveBeforeAction) {
      return workflowConfigurationId
        ? 'Please save your latest changes before executing.'
        : 'Please save the workflow before executing.';
    }
    if (executing) {
      return 'Execute request in progress...';
    }
    if (runStatus?.status === 'ACTIVE' || runStatus?.status === 'PROCESSING') {
      return 'Workflow execution is already in progress.';
    }
    return null;
  })();

  const startScheduledPolling = () => {
    if (scheduledPollingRef.current) return;

    setSelectedDate(null);
    setSelectedTime(null);
    setFrequency('');
    setEndDate(null);
    setRecurrenceEnabled(false);
    setCustomDays([]);
    setHourInterval(1);

    const pollScheduled = async () => {
      try {
        const status = await fetchScheduledStatus(workflowId);
        dispatch(setScheduledStatus({ workflowId, scheduledStatus: status }));

        const runId = status?.latest_run?.workflow_run_id;

        if (runId) {
          if (isPolling) {
            return;
          }

          clearInterval(scheduledPollingRef.current);
          scheduledPollingRef.current = null;

          dispatch(
            saveWorkflow({
              nodes: workflowData?.nodes || [],
              edges: workflowData?.edges || [],
              connectionDetails: workflowData?.connectionDetails || [],
              workflowId: workflowData?.workflowId || workflowId,
              workflowConfigurationId: workflowData?.workflowConfigurationId,
              workflowRunId: runId,
            }),
          );

          fetchStatus(runId);
          setIsPolling(true);
          pollingRef.current = setInterval(() => {
            fetchStatus(runId);
          }, 10000);
        }
      } catch (e) {
        console.warn('Scheduled status polling failed:', e);
      }
    };

    pollScheduled();
    scheduledPollingRef.current = setInterval(pollScheduled, 10000);
  };

  useEffect(() => {
    if (
      shouldSaveAfterSchedule &&
      workflowData?.scheduleDateTime &&
      workflowData?.timezone
    ) {
      if (typeof onSave === 'function') onSave();
      setShouldSaveAfterSchedule(false);
    }
  }, [
    workflowData?.scheduleDateTime,
    workflowData?.timezone,
    shouldSaveAfterSchedule,
  ]);

  useEffect(() => {
    if (!scheduleLockUntil) return;
    const checkLock = () => {
      if (dayjs(scheduleLockUntil).isBefore(dayjs())) {
        dispatch(setScheduleLockUntil({ workflowId, lockUntil: null }));
      }
    };
    checkLock();
    const interval = setInterval(checkLock, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, [scheduleLockUntil, workflowId, dispatch]);

  useEffect(() => {
    const terminalStates = ['SUCCESS', 'FAILED', 'PARTIAL_SUCCESS'];
    if (
      scheduledStatus?.status === 'SCHEDULED' &&
      terminalStates.includes((runStatus?.status || '').toUpperCase()) &&
      !scheduledPollingRef.current
    ) {
      startScheduledPolling();
    }
  }, [scheduledStatus?.status, runStatus?.status]);

  useEffect(() => {
    const scheduledWorkflowId = triggerData?.workflow_id;

    if (triggerData?.status === 'SCHEDULED' && scheduledWorkflowId) {
      startScheduledPolling();
    }

    setSelectedDate(null);
    setSelectedTime(null);
    return () => {
      if (scheduledPollingRef.current) {
        clearInterval(scheduledPollingRef.current);
        scheduledPollingRef.current = null;
      }
    };
  }, [triggerData, dispatch, workflowId]);

  const handleScheduleOpen = () => {
    if (mustSaveBeforeAction) {
      toast.error(
        workflowConfigurationId
          ? 'Please save your latest changes before scheduling.'
          : 'Please save the workflow before scheduling.',
        {
          autoClose: 3000,
        },
      );
      return;
    }
    clearAllTimers();
    setRunStatus(null);
    setSelectedDate(null);
    setSelectedTime(null);
    setFrequency('');
    setEndDate(null);
    setRecurrenceEnabled(true);
    setCustomDays([]);
    setHourInterval(1);
    dispatch(setTriggerResponse({ workflowId, triggerResponse: null }));
    dispatch(setScheduledStatus({ workflowId, scheduledStatus: null }));
    dispatch(
      setScheduleDateTime({
        workflowId,
        scheduleDateTime: null,
        timezone: null,
        frequency: null,
        endDate: null,
        customDays: null,
        hourInterval: null,
      }),
    );

    setScheduleDialogOpen(true);
  };

  const handleScheduleClose = () => {
    setScheduleDialogOpen(false);
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  const handleTimeChange = (newTime) => {
    setSelectedTime(newTime);
  };

  const handleCancelFlow = async () => {
    try {
      await triggerCancelWorkflow(workflowRunId);
      toast.success('Workflow execution cancelled.');

      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
      setIsPolling(false);

      dispatch(
        saveWorkflow({
          ...workflowData,
          workflowId: workflowId,
          workflowRunId: null,
        }),
      );

      setRunStatus(null);
    } catch (err) {
      toast.error('Failed to cancel workflow execution.');
      console.error(err);
    }
  };

  const handleCancelSchedule = async () => {
    try {
      await cancelWorkflowSchedule(workflowId);
      toast.success('Schedule cancelled.');

      // Stop any schedule-related timers and clear scheduled state
      clearAllTimers();
      dispatch(setScheduledStatus({ workflowId, scheduledStatus: null }));
      dispatch(setTriggerResponse({ workflowId, triggerResponse: null }));
      dispatch(
        setScheduleDateTime({
          workflowId,
          scheduleDateTime: null,
          timezone: null,
          frequency: null,
          endDate: null,
          customDays: null,
          hourInterval: null,
        }),
      );
      dispatch(setScheduleLockUntil({ workflowId, lockUntil: null }));
    } catch (err) {
      toast.error('Failed to cancel schedule.');
      console.error(err);
    }
  };

  const handleViewJiraTicket = () => {
    if (runStatus?.jira_ticket_url) {
      window.open(runStatus.jira_ticket_url, '_blank');
    }
  };

  // optional: tiny helper
  const clearAllTimers = () => {
    if (pollingRef.current) clearInterval(pollingRef.current);
    if (postPollTimeoutRef.current) clearTimeout(postPollTimeoutRef.current);
    pollingRef.current = null;
    postPollTimeoutRef.current = null;

    if (scheduledPollingRef.current) {
      clearInterval(scheduledPollingRef.current);
      scheduledPollingRef.current = null;
    }
  };

  const stopPollingAndScheduleFollowUp = (runId) => {
    if (pollingRef.current) clearInterval(pollingRef.current);
    setIsPolling(false);

    // Allow up to 2 follow-up fetches (10 seconds apart each)
    if (followUpCountRef.current < 2) {
      followUpCountRef.current += 1;
      postPollTimeoutRef.current = setTimeout(() => {
        fetchStatus(runId);
      }, 10000);
    }
  };

  const handleCheckExecution = () => {
    if (mustSaveBeforeAction) {
      toast.error(
        workflowConfigurationId
          ? 'Please save your latest changes before executing.'
          : 'Please save the workflow before executing.',
        {
          autoClose: 3000,
        },
      );
      return;
    }
    dispatch(
      setBlinkByWorkflow({ workflowId, button: 'execute', value: false }),
    );
    if (workflowRunId) {
      onWorkflowExecutionComplete(workflowId);
    }

    setTimeout(() => {
      handleExecute();
    }, 2000);
  };

  const handleExecute = async () => {
    if (mustSaveBeforeAction || !workflowId) {
      toast.error(
        workflowConfigurationId
          ? 'Please save your latest changes before executing.'
          : 'Please save the workflow before executing.',
        {
          autoClose: 3000,
        },
      );
      return;
    }

    clearAllTimers();
    // Prevent schedule UI and polling from interfering with on-demand run
    dispatch(setTriggerResponse({ workflowId, triggerResponse: null }));
    dispatch(setScheduledStatus({ workflowId, scheduledStatus: null }));
    followUpCountRef.current = 0;

    setExecuting(true);
    setRunStatus(null);

    try {
      const response = await triggerExecuteWorkflow(workflowId);
      onCollapsedChange?.(true);
      toast.success('Workflow execution triggered.', {
        autoClose: 2000,
      });

      if (response.workflow_run_id) {
        dispatch(
          saveWorkflow({
            nodes: workflowData?.nodes || [],
            edges: workflowData?.edges || [],
            connectionDetails: workflowData?.connectionDetails || [],
            workflowId: workflowData?.workflowId,
            workflowConfigurationId: workflowData?.workflowConfigurationId,
            workflowRunId: response.workflow_run_id,
          }),
        );

        try {
          await sendNotification({
            to_email: Cookies.get('userEmail'),
            subject: 'Workflow Started',
            message: `Workflow ${workflowName} started. Run ID: ${response.workflow_run_id}`,
            workflow_id: workflowId,
            workflow_name: workflowName,
          });
        } catch (e) {
          console.warn('Notification email failed:', e);
        }

        fetchStatus(response.workflow_run_id);
        setIsPolling(true);
        pollingRef.current = setInterval(() => {
          fetchStatus(response.workflow_run_id);
        }, 10000);
      }
    } catch (error) {
      console.log('execution error:', error);
      toast.error('Failed to trigger execution');
    } finally {
      setExecuting(false);
    }
  };

  useImperativeHandle(
    ref,
    () => ({
      runNow: handleCheckExecution,
      runImmediately: handleExecute,
      openSchedule: handleScheduleOpen,
      refreshStatus: () => {
        if (workflowRunId) fetchStatus(workflowRunId);
      },
    }),
    [workflowRunId, mustSaveBeforeAction],
  );

  useEffect(() => {
    if (location.state?.runNow) {
      handleCheckExecution();
    }
    window.history.replaceState({}, document.title);
  }, [location.state]);

  const fetchStatus = async (runId) => {
    setIsRefreshing(true);

    const minDuration = 3000;
    const startTime = Date.now();

    try {
      const statusData = await fetchWorkflowRunStatus(runId);
      setRunStatus(statusData);

      if (statusRef.current && scrolledRunRef.current !== runId) {
        scrolledRunRef.current = runId;

        setTimeout(() => {
          statusRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }, 0);
      }

      const terminalStates = ['SUCCESS', 'FAILED', 'PARTIAL_SUCCESS'];
      if (terminalStates.includes(statusData.status?.toUpperCase())) {
        stopPollingAndScheduleFollowUp(runId);
      }
    } catch (err) {
      setRunStatus({
        status: 'Error fetching status',
        error_message: err.message,
      });

      stopPollingAndScheduleFollowUp(runId);
    } finally {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(minDuration - elapsed, 0);
      setTimeout(() => setIsRefreshing(false), remaining);
    }
  };

  useEffect(() => {
    return () => {
      clearAllTimers();
    };
  }, []);

  // Reset previous success counts when workflowRunId changes
  useEffect(() => {
    if (workflowRunId && !previousSuccessCountsRef.current[workflowRunId]) {
      previousSuccessCountsRef.current[workflowRunId] = {};
    }
  }, [workflowRunId]);

  return (
    <>
      <Container>
        <Box
          sx={{
            display: 'flex',
            justifyContent: selectedNode?.id ? 'center' : 'center',
            gap: 4,
            mb: 2,
          }}
        >
          {runStatus?.jira_ticket_url && (
            <Button
              variant="outlined"
              sx={{
                borderRadius: 0.5,
                color: darkMode ? '#ffffff' : '#1976d2',
                borderColor: darkMode ? '#64748b' : '#1976d2',
                '&:hover': {
                  backgroundColor: darkMode
                    ? 'rgba(100, 116, 139, 0.1)'
                    : 'rgba(25, 118, 210, 0.04)',
                  borderColor: darkMode ? '#94a3b8' : '#1565c0',
                },
              }}
              onClick={handleViewJiraTicket}
              startIcon={<LaunchIcon />}
            >
              View Jira Ticket
            </Button>
          )}

          <motion.div
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25, ease: 'easeOut', delay: 0.05 }}
          >
            {(() => {
              const button = (
                <span style={{ display: 'inline-block' }}>
                  <Button
                    variant="outlined"
                    sx={{
                      borderRadius: 0.5,
                      color: '#fff',
                      borderColor: '#4C5B9A',
                      backgroundColor: '#5965A6',
                      opacity: scheduleDisabled ? 0.7 : 1,
                      pointerEvents: scheduleDisabled ? 'none' : 'auto',
                      '&:hover': {
                        background: 'rgb(61, 74, 125)',
                        border:
                          '1px solid linear-gradient(90deg, #0056D2 0%, #002C6C 100%)',
                      },
                    }}
                    onClick={handleScheduleOpen}
                    disabled={scheduleDisabled}
                  >
                    Schedule
                  </Button>
                </span>
              );
              if (!scheduleTooltip) {
                return button;
              }
              return <Tooltip title={scheduleTooltip}>{button}</Tooltip>;
            })()}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25, ease: 'easeOut', delay: 0.08 }}
          >
            <motion.div
              animate={
                executeBlink
                  ? {
                      opacity: [1, 0.7, 1],
                      scale: [1, 1.04, 1],
                      boxShadow: [
                        '0 0 0px rgba(0,0,0,0)',
                        '0 0 12px rgba(0, 123, 255, 0.6)',
                        '0 0 0px rgba(0,0,0,0)',
                      ],
                    }
                  : {}
              }
              transition={
                executeBlink
                  ? {
                      repeat: Infinity,
                      repeatType: 'loop',
                      duration: 0.8,
                      ease: 'easeInOut',
                    }
                  : {}
              }
              style={{ display: 'inline-block', borderRadius: '10px' }}
            >
              {(() => {
                const executeButton = (
                  <span style={{ display: 'inline-block' }}>
                    <Button
                      variant="outlined"
                      sx={{
                        borderRadius: 0.5,
                        color: '#5965A6',
                        borderColor: '#4C5B9A',
                        opacity: executeDisabled ? 0.7 : 1,
                        pointerEvents: executeDisabled ? 'none' : 'auto',
                        '&:hover': {
                          backgroundColor: 'rgb(61, 74, 125)',
                          color: darkMode ? '#ffffff' : 'white',
                        },
                      }}
                      onClick={handleCheckExecution}
                      disabled={executeDisabled}
                    >
                      {executing ? 'Executing...' : 'Execute'}
                    </Button>
                  </span>
                );

                if (!executeTooltip) {
                  return executeButton;
                }

                return (
                  <Tooltip title={executeTooltip}>{executeButton}</Tooltip>
                );
              })()}
            </motion.div>
          </motion.div>
        </Box>

        <Dialog
          open={scheduleDialogOpen}
          onClose={handleScheduleClose}
          sx={{
            '& .MuiDialog-paper': {
              borderRadius: 2,
              width: 500,
              height: 'auto',
              backgroundColor: darkMode ? '#282828' : '#ffffff',
              color: darkMode ? '#ffffff' : 'inherit',
            },
            // Calendar popup styling
            '& .MuiPickersDay-root.Mui-selected': {
              backgroundColor: '#5965A6',
              color: '#ffffff',
              '&:hover': {
                backgroundColor: '#4C5B9A',
              },
            },
            '& .MuiPickersDay-root.Mui-disabled': {
              color: darkMode
                ? 'rgba(255, 255, 255, 0.3)'
                : 'rgba(0, 0, 0, 0.26)',
            },
            '& .MuiPickersArrowSwitcher-button': {
              color: '#5965A6',
            },
            '& .MuiPickersCalendarHeader-label': {
              color: darkMode ? '#ffffff' : 'inherit',
            },
            '& .MuiPickersDay-root:not(.Mui-selected):not(.Mui-disabled)': {
              '&:hover': {
                backgroundColor: darkMode
                  ? 'rgba(89, 101, 166, 0.1)'
                  : 'rgba(89, 101, 166, 0.08)',
              },
            },
          }}
        >
          <DialogTitle>Select Date & Time</DialogTitle>
          <DialogContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              justifyContent: 'center',
              alignItems: 'center',
              p: 2,
              overflow: 'visible',
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ width: '100%' }}>
                <DatePicker
                  label="Schedule Date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  minDate={dayjs()}
                  sx={{
                    width: '100%',
                    '& .MuiInputBase-root': {
                      color: darkMode ? '#ffffff' : 'inherit',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: darkMode
                        ? 'rgba(255, 255, 255, 0.23)'
                        : 'rgba(0, 0, 0, 0.23)',
                    },
                    '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                      {
                        borderColor: '#5965A6',
                      },
                    '& .MuiInputLabel-root': {
                      color: darkMode
                        ? 'rgba(255, 255, 255, 0.7)'
                        : 'rgba(0, 0, 0, 0.6)',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: '#5965A6',
                    },
                    '& .MuiSvgIcon-root': {
                      color: darkMode ? 'rgba(255, 255, 255, 0.7)' : '#5965A6',
                    },
                  }}
                />
              </Box>
              <Box sx={{ width: '100%' }}>
                <TimePicker
                  label="Schedule Time"
                  value={selectedTime}
                  onChange={handleTimeChange}
                  minutesStep={1}
                  // format="hh:mm A"
                  timeSteps={{ minutes: 1 }}
                  ampm={false} // ✅ Use 24-hour format
                  minTime={
                    selectedDate && dayjs(selectedDate).isSame(dayjs(), 'day')
                      ? dayjs()
                      : dayjs().startOf('day')
                  }
                  sx={{
                    width: '100%',
                    '& .MuiInputBase-root': {
                      color: darkMode ? '#ffffff' : 'inherit',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: darkMode
                        ? 'rgba(255, 255, 255, 0.23)'
                        : 'rgba(0, 0, 0, 0.23)',
                    },
                    '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                      {
                        borderColor: '#5965A6',
                      },
                    '& .MuiInputLabel-root': {
                      color: darkMode
                        ? 'rgba(255, 255, 255, 0.7)'
                        : 'rgba(0, 0, 0, 0.6)',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: '#5965A6',
                    },
                    '& .MuiSvgIcon-root': {
                      color: darkMode ? 'rgba(255, 255, 255, 0.7)' : '#5965A6',
                    },
                  }}
                />
              </Box>
              {/* Recurrence toggle */}
              <Box sx={{ width: '100%' }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={recurrenceEnabled}
                      onChange={(e) => setRecurrenceEnabled(e.target.checked)}
                      inputProps={{ 'aria-label': 'Enable recurrence' }}
                      sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                          color: '#5965A6',
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
                          {
                            backgroundColor: '#5965A6',
                          },
                      }}
                    />
                  }
                  label="Enable Recurrence"
                  sx={{
                    color: darkMode ? '#ffffff' : 'inherit',
                  }}
                />
              </Box>

              {/* Recurrence pattern options */}
              {recurrenceEnabled && (
                <Box sx={{ width: '100%' }}>
                  <FormLabel
                    id="recurrence-pattern-label"
                    sx={{
                      fontSize: 14,
                      color: darkMode
                        ? 'rgba(255,255,255,0.7)'
                        : 'rgba(0,0,0,0.6)',
                      mb: 0.5,
                    }}
                  >
                    Recurrence Pattern
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="recurrence-pattern-label"
                    name="recurrence"
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value)}
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                      gap: 1,
                    }}
                  >
                    <FormControlLabel
                      value="hourly"
                      control={
                        <Radio
                          sx={{
                            color: darkMode
                              ? 'rgba(255, 255, 255, 0.7)'
                              : '#5965A6',
                            '&.Mui-checked': {
                              color: '#5965A6',
                            },
                          }}
                        />
                      }
                      label="Hourly"
                    />
                    <FormControlLabel
                      value="daily"
                      control={
                        <Radio
                          sx={{
                            color: darkMode
                              ? 'rgba(255, 255, 255, 0.7)'
                              : '#5965A6',
                            '&.Mui-checked': {
                              color: '#5965A6',
                            },
                          }}
                        />
                      }
                      label="Daily"
                    />
                    <FormControlLabel
                      value="weekly"
                      control={
                        <Radio
                          sx={{
                            color: darkMode
                              ? 'rgba(255, 255, 255, 0.7)'
                              : '#5965A6',
                            '&.Mui-checked': {
                              color: '#5965A6',
                            },
                          }}
                        />
                      }
                      label="Weekly"
                    />
                    <FormControlLabel
                      value="monthly"
                      control={
                        <Radio
                          sx={{
                            color: darkMode
                              ? 'rgba(255, 255, 255, 0.7)'
                              : '#5965A6',
                            '&.Mui-checked': {
                              color: '#5965A6',
                            },
                          }}
                        />
                      }
                      label="Monthly"
                    />
                  </RadioGroup>
                </Box>
              )}

              {/* Hourly interval input */}
              {recurrenceEnabled && frequency === 'hourly' && (
                <Box sx={{ width: '100%' }}>
                  <TextField
                    type="number"
                    label="Repeat every (hours)"
                    value={hourInterval}
                    onChange={(e) => {
                      const val = e.target.value;
                      // allow empty while typing, else clamp 1-24
                      if (val === '') return setHourInterval('');
                      const num = Number(val);
                      if (!Number.isNaN(num)) {
                        setHourInterval(
                          Math.max(1, Math.min(24, Math.floor(num))),
                        );
                      }
                    }}
                    inputProps={{
                      min: 1,
                      max: 24,
                      step: 1,
                      'aria-label': 'Hourly interval in hours',
                    }}
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-root': {
                        color: darkMode ? '#ffffff' : 'inherit',
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: darkMode
                          ? 'rgba(255, 255, 255, 0.23)'
                          : 'rgba(0, 0, 0, 0.23)',
                      },
                      '& .MuiInputLabel-root': {
                        color: darkMode
                          ? 'rgba(255, 255, 255, 0.7)'
                          : 'rgba(0, 0, 0, 0.6)',
                      },
                    }}
                  />
                </Box>
              )}

              {recurrenceEnabled && frequency === 'weekly' && (
                <Box sx={{ width: '100%' }}>
                  <FormLabel
                    id="days-of-week-label"
                    sx={{
                      fontSize: 14,
                      color: darkMode
                        ? 'rgba(255,255,255,0.7)'
                        : 'rgba(0,0,0,0.6)',
                      mb: 0.5,
                    }}
                  >
                    Select Days
                  </FormLabel>
                  <FormGroup
                    role="group"
                    aria-labelledby="days-of-week-label"
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(7, 1fr)',
                      gap: 1,
                    }}
                  >
                    {[
                      { key: 'monday', label: 'M' },
                      { key: 'tuesday', label: 'T' },
                      { key: 'wednesday', label: 'W' },
                      { key: 'thursday', label: 'TH' },
                      { key: 'friday', label: 'F' },
                      { key: 'saturday', label: 'S' },
                      { key: 'sunday', label: 'SU' },
                    ].map((d) => (
                      <FormControlLabel
                        key={d.key}
                        control={
                          <Checkbox
                            checked={customDays.includes(d.key)}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setCustomDays((prev) => {
                                if (checked) return [...prev, d.key];
                                return prev.filter((x) => x !== d.key);
                              });
                            }}
                            inputProps={{ 'aria-label': d.key }}
                            sx={{
                              color: darkMode
                                ? 'rgba(255, 255, 255, 0.7)'
                                : '#5965A6',
                              '&.Mui-checked': {
                                color: '#5965A6',
                              },
                            }}
                          />
                        }
                        label={d.label}
                      />
                    ))}
                  </FormGroup>
                </Box>
              )}

              {/* End Date (required when frequency selected) */}
              <Box sx={{ width: '100%' }}>
                <DatePicker
                  label={frequency ? 'End Date (required)' : 'End Date'}
                  value={endDate}
                  onChange={(d) => setEndDate(d)}
                  disabled={!frequency}
                  minDate={
                    selectedDate
                      ? dayjs(selectedDate).add(1, 'day')
                      : dayjs().add(1, 'day')
                  }
                  shouldDisableDate={(date) => {
                    // Disable the start date itself if it's selected
                    if (selectedDate) {
                      return dayjs(date).isSame(dayjs(selectedDate), 'day');
                    }
                    return false;
                  }}
                  sx={{
                    width: '100%',
                    '& .MuiInputBase-root': {
                      color: darkMode ? '#ffffff' : 'inherit',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: darkMode
                        ? 'rgba(255, 255, 255, 0.23)'
                        : 'rgba(0, 0, 0, 0.23)',
                    },
                    '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                      {
                        borderColor: '#5965A6',
                      },
                    '& .MuiInputLabel-root': {
                      color: darkMode
                        ? 'rgba(255, 255, 255, 0.7)'
                        : 'rgba(0, 0, 0, 0.6)',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: '#5965A6',
                    },
                    '& .MuiSvgIcon-root': {
                      color: darkMode ? 'rgba(255, 255, 255, 0.7)' : '#5965A6',
                    },
                  }}
                />
              </Box>
            </LocalizationProvider>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={handleScheduleClose}
              sx={{
                color: '#5965A6',
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={async () => {
                let runAtLocal = null;
                if (selectedDate && selectedTime) {
                  const datePart = selectedDate.format('YYYY-MM-DD');
                  const timePart = selectedTime.format('HH:mm:ss');
                  runAtLocal = `${datePart}T${timePart}`;
                }
                const timezone =
                  Intl.DateTimeFormat().resolvedOptions().timeZone;

                // Recurrence validations
                if (recurrenceEnabled && !frequency) {
                  toast.error('Please select a recurrence pattern.', {
                    autoClose: 3000,
                  });
                  return;
                }
                if (
                  recurrenceEnabled &&
                  frequency === 'weekly' &&
                  customDays.length === 0
                ) {
                  toast.error(
                    'Please select at least one day for weekly recurrence.',
                    {
                      autoClose: 3000,
                    },
                  );
                  return;
                }

                // Validation: if frequency selected, end date is mandatory
                if (frequency && !endDate) {
                  toast.error(
                    'Please select an end date for recurring schedule.',
                    {
                      autoClose: 3000,
                    },
                  );
                  return;
                }

                // Additional guard: end date must not be before start date
                if (frequency && endDate && selectedDate) {
                  const isBefore = dayjs(endDate).isBefore(
                    dayjs(selectedDate),
                    'day',
                  );
                  if (isBefore) {
                    toast.error('End date cannot be before the start date.', {
                      autoClose: 3000,
                    });
                    return;
                  }
                }

                // Ensure end date (if provided) is in the future
                if (endDate) {
                  const endOfDay = dayjs(endDate).endOf('day');
                  if (!endOfDay.isAfter(dayjs())) {
                    toast.error('End date must be in the future.', {
                      autoClose: 3000,
                    });
                    return;
                  }
                }

                // Hourly interval validation (1-24)
                if (recurrenceEnabled && frequency === 'hourly') {
                  const n = Number(hourInterval);
                  if (!Number.isInteger(n) || n < 1 || n > 24) {
                    toast.error('Please enter hours between 1 and 24.', {
                      autoClose: 3000,
                    });
                    return;
                  }
                }

                dispatch(
                  setScheduleDateTime({
                    workflowId: workflowId,
                    scheduleDateTime: runAtLocal,
                    timezone,
                    frequency:
                      recurrenceEnabled && frequency
                        ? String(frequency).toUpperCase()
                        : null,
                    endDate: endDate ? endDate.format('YYYY-MM-DD') : null,
                    customDays:
                      recurrenceEnabled && frequency === 'weekly'
                        ? customDays
                        : null,
                    hourInterval:
                      recurrenceEnabled && frequency === 'hourly'
                        ? Number(hourInterval)
                        : null,
                  }),
                );

                // Set schedule lock until end date passes (persisted)
                if (endDate) {
                  const lockUntilIso = dayjs(endDate)
                    .endOf('day')
                    .toISOString();
                  if (dayjs(lockUntilIso).isAfter(dayjs())) {
                    dispatch(
                      setScheduleLockUntil({
                        workflowId,
                        lockUntil: lockUntilIso,
                      }),
                    );
                  }
                }

                setRunStatus(null);
                handleScheduleClose();

                setShouldSaveAfterSchedule(true);
                // reset local frequency/endDate
                setFrequency('');
                setEndDate(null);
                setRecurrenceEnabled(false);
                setCustomDays([]);
                setHourInterval(1);

                // After confirm, call scheduled-status directly using same workflow_id
                try {
                  const status = await fetchScheduledStatus(workflowId);
                  dispatch(
                    setScheduledStatus({ workflowId, scheduledStatus: status }),
                  );
                  // Start polling until latest_run appears
                  startScheduledPolling();
                } catch (e) {
                  console.warn(
                    'Failed to fetch scheduled status after confirmation:',
                    e,
                  );
                }
              }}
              sx={{
                color: '#5965A6',
              }}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Container>

      <Box
        sx={{
          my: 2,
          width: '100%',
          maxWidth: collapsedBoth ? 'calc(100% - 160px)' : 'calc(100% - 550px)',
          mx: 'auto',
          transition: 'max-width 0.4s ease-in-out',
          // mr: 1,
        }}
      >
        <Paper
          ref={statusRef}
          elevation={3}
          sx={{
            p: 3,
            minHeight: 140,
            maxHeight: 550,
            overflowY: 'auto',
            bgcolor: darkMode ? '#0F172A' : '#F9F9FB',
            color: darkMode ? '#E2E8F0' : '#1e293b',
            fontSize: 14,
            borderRadius: '8px',
            border: darkMode ? '1px solid #334155' : '1px solid #1e3a5f',
            boxShadow: darkMode
              ? '0 2px 10px rgba(148, 163, 184, 0.1)'
              : '0 2px 10px rgba(30, 58, 95, 0.15)',
          }}
        >
          {/* Run ID */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              zIndex: 1000,
              background:
                'linear-gradient(135deg, #4A558F 0%, #5965A6 50%, #7B84C1 100%)',
              color: '#fff',
              py: '0.15rem',
              px: 2,
              borderRadius: '8px 8px 0 0',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Typography>
                {scheduledStatus?.status === 'SCHEDULED' && workflowRunId
                  ? scheduledStatus?.message
                  : workflowRunId
                    ? `Workflow Run ID: ${workflowRunId}`
                    : 'No workflow run has been executed yet.'}
              </Typography>
              {workflowRunId && (
                <>
                  <Typography>-</Typography>
                  <Tooltip title="View Logs">
                    <IconButton
                      onClick={() => setLogsDialogOpen(true)}
                      size="small"
                      sx={{
                        color: 'inherit',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        },
                      }}
                    >
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="View Simple Logs">
                    <IconButton
                      onClick={() => setSimpleLogsDialogOpen(true)}
                      size="small"
                      sx={{
                        color: 'inherit',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        },
                      }}
                    >
                      <LaunchIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              )}

              {scheduledStatus?.status === 'SCHEDULED' && (
                <Tooltip title="Cancel Schedule">
                  <IconButton
                    onClick={handleCancelSchedule}
                    size="small"
                    sx={{
                      color: 'inherit',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      },
                    }}
                  >
                    <CancelOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>

            {workflowRunId && !timezone && (
              <Box position="relative" display="inline-flex" gap={1}>
                {/* ✅ Cancel Flow button: show only when ACTIVE or PROCESSING */}
                {(runStatus?.status === 'ACTIVE' ||
                  runStatus?.status === 'PROCESSING') && (
                  <Tooltip title="Cancel Flow">
                    <IconButton
                      onClick={handleCancelFlow}
                      size="medium"
                      sx={{ color: 'inherit' }}
                    >
                      <CancelOutlinedIcon size="large" />
                    </IconButton>
                  </Tooltip>
                )}

                {/* ✅ Refresh button: show always if workflowRunId exists */}
                <Tooltip title="Refresh">
                  <IconButton
                    size="medium"
                    onClick={() => fetchStatus(workflowRunId)}
                    disabled={isRefreshing}
                    sx={{ color: 'inherit' }}
                  >
                    {isRefreshing ? (
                      <CircularProgress size={22} sx={{ color: '#fff' }} />
                    ) : (
                      <RefreshIcon />
                    )}
                  </IconButton>
                </Tooltip>
                <Tooltip title={executeTooltip || 'Execute'}>
                  <span style={{ display: 'inline-flex' }}>
                    <IconButton
                      size="medium"
                      onClick={handleCheckExecution}
                      sx={{ color: 'inherit' }}
                      disabled={executeDisabled}
                    >
                      <PlayCircleOutlineIcon />
                    </IconButton>
                  </span>
                </Tooltip>

                {/* ✅ View Jira Ticket button: show if jira_ticket_url exists */}
                {runStatus?.jira_ticket_url && (
                  <Tooltip title="View Jira Ticket">
                    <IconButton
                      size="medium"
                      onClick={handleViewJiraTicket}
                      sx={{ color: 'inherit' }}
                    >
                      <LaunchIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
          </Box>
          {/* Overall Progress Bar */}
          {runStatus?.steps_by_phase &&
            (() => {
              const stepsByPhase = runStatus.steps_by_phase || {};
              const stepsByEntity = runStatus.steps_by_entity || [];
              const workflowStatus = runStatus.status?.toUpperCase() || '';

              // Define the order of phases (extract is always first)
              const orderedPhases = [
                'extract',
                'transform',
                'decision',
                'load',
                'backtrack',
              ];

              // Check if we have entity data
              const hasEntityData = stepsByEntity && stepsByEntity.length > 0;
              // Determine if single entity (use steps_by_phase) or multiple entities (use steps_by_entity)
              const isSingleEntity =
                !hasEntityData || stepsByEntity.length === 1;

              // Early return if no data
              if (!hasEntityData && !stepsByPhase.extract) {
                return null;
              }

              // Initialize previous counts if not exists
              if (!previousSuccessCountsRef.current[workflowRunId]) {
                previousSuccessCountsRef.current[workflowRunId] = {};
              }
              const previousCounts =
                previousSuccessCountsRef.current[workflowRunId];

              // Calculate progress for single entity using steps_by_phase
              const calculateSingleEntityProgress = (phase) => {
                const phaseStep = stepsByPhase[phase] || {};
                const extractStep = stepsByPhase.extract || {};

                const extractSuccess = extractStep.success_record_count || 0;
                const extractFailure = extractStep.failure_record_count || 0;
                const extractTotal = extractSuccess + extractFailure;

                const phaseSuccess = phaseStep.success_record_count || 0;

                if (phase === 'extract') {
                  // For extract: show progress immediately when data exists
                  // Track max to only show increases
                  const stepStatus =
                    extractStep.step_status?.toUpperCase() || '';
                  const key = `single_${phase}_total`;
                  const previousTotal = previousCounts[key] || 0;
                  const maxTotal = Math.max(extractTotal, previousTotal);
                  previousCounts[key] = maxTotal;

                  const successKey = `single_${phase}_success`;
                  const previousSuccess = previousCounts[successKey] || 0;
                  const maxSuccess = Math.max(extractSuccess, previousSuccess);
                  previousCounts[successKey] = maxSuccess;

                  // If extract has started (has any records), show progress immediately
                  if (extractTotal > 0) {
                    // If step is SUCCESS, show 100%
                    if (stepStatus === 'SUCCESS') {
                      return 100;
                    }
                    // Progress = (success records / total records) * 100
                    // This shows progress as extract happens
                    return Math.min((maxSuccess / maxTotal) * 100, 100);
                  }

                  // If we have success but no total yet, extract just started
                  if (extractSuccess > 0) {
                    return 10; // Show 10% when extract starts
                  }

                  return 0;
                } else {
                  // For transform/load: progress based on success count only
                  // Show 100% only when step_status is SUCCESS AND counts match
                  const stepStatus = phaseStep.step_status?.toUpperCase() || '';
                  const key = `single_${phase}_success`;
                  const previousSuccess = previousCounts[key] || 0;
                  const maxSuccess = Math.max(phaseSuccess, previousSuccess);
                  previousCounts[key] = maxSuccess;

                  if (extractTotal > 0) {
                    // If step is SUCCESS, verify counts match before showing 100%
                    if (stepStatus === 'SUCCESS') {
                      // Only show 100% if success count matches or exceeds extract total
                      if (maxSuccess >= extractTotal) {
                        return 100;
                      }
                      // If SUCCESS but counts don't match yet, calculate based on actual progress
                      return Math.min((maxSuccess / extractTotal) * 100, 100);
                    }
                    // Otherwise, calculate based on success count only
                    return Math.min((maxSuccess / extractTotal) * 100, 100);
                  }
                  return 0;
                }
              };

              // Get extract baseline from steps_by_entity (per entity)
              const getEntityExtractTotal = (entity) => {
                const extractStep = entity.extract || {};
                const success = extractStep.success_record_count || 0;
                const failure = extractStep.failure_record_count || 0;
                return success + failure;
              };

              // Get extract success count for an entity (for transform/load comparison)
              const getEntityExtractSuccess = (entity) => {
                const extractStep = entity.extract || {};
                return extractStep.success_record_count || 0;
              };

              // Get baseline for decision workflows: use decision routing or source extract
              const getEntityBaselineForDecision = (entity, phase) => {
                // If entity has extract data, use it
                const entityExtractSuccess = getEntityExtractSuccess(entity);
                if (entityExtractSuccess > 0) {
                  return entityExtractSuccess;
                }

                // For load phase in decision workflows, check decision routing_breakdown
                if (phase === 'load') {
                  // First, check if this entity has a decision step with routing_breakdown
                  // In decision workflows, each entity's decision step shows routing for that entity
                  const decisionStep = entity.decision || {};
                  const routingBreakdown = decisionStep.routing_breakdown || [];

                  if (routingBreakdown.length > 0) {
                    // Sum up all records routed from this entity's decision step
                    // This represents what should be loaded for destinations routed from this entity
                    const totalRouted = routingBreakdown.reduce(
                      (sum, route) => sum + (route.records || 0),
                      0,
                    );
                    if (totalRouted > 0) {
                      return totalRouted;
                    }
                  }

                  // Check other entities for decision routing that might route to this entity
                  // Look for decision steps in other entities that route to this entity
                  // Match by checking if load step name matches connection name
                  const loadStep = entity.load || {};
                  const loadStepName = loadStep.step_name || '';

                  for (const otherEntity of stepsByEntity) {
                    const otherDecision = otherEntity.decision || {};
                    const otherRouting = otherDecision.routing_breakdown || [];
                    for (const route of otherRouting) {
                      // Try to match by connection name in load step name
                      if (
                        route.connection_name &&
                        loadStepName &&
                        loadStepName
                          .toLowerCase()
                          .includes(route.connection_name.toLowerCase())
                      ) {
                        return route.records || 0;
                      }
                      // Also try matching entity name with connection name
                      if (
                        route.connection_name &&
                        entity.entity &&
                        (route.connection_name
                          .toLowerCase()
                          .includes(entity.entity.toLowerCase()) ||
                          entity.entity
                            .toLowerCase()
                            .includes(route.connection_name.toLowerCase()))
                      ) {
                        return route.records || 0;
                      }
                    }
                  }

                  // Check global decision step (steps_by_phase) for routing
                  const globalDecision = stepsByPhase.decision || {};
                  const globalRouting = globalDecision.routing_breakdown || [];
                  for (const route of globalRouting) {
                    if (
                      route.connection_name &&
                      (loadStepName
                        .toLowerCase()
                        .includes(route.connection_name.toLowerCase()) ||
                        (entity.entity &&
                          (route.connection_name
                            .toLowerCase()
                            .includes(entity.entity.toLowerCase()) ||
                            entity.entity
                              .toLowerCase()
                              .includes(route.connection_name.toLowerCase()))))
                    ) {
                      return route.records || 0;
                    }
                  }
                }

                // For transform phase, find source entity (one with extract data) and use its extract count
                if (phase === 'transform') {
                  const sourceEntity = stepsByEntity.find(
                    (e) => getEntityExtractSuccess(e) > 0,
                  );
                  if (sourceEntity) {
                    return getEntityExtractSuccess(sourceEntity);
                  }
                }

                // Fallback: find source entity (one with extract data) and use its extract count
                const sourceEntity = stepsByEntity.find(
                  (e) => getEntityExtractSuccess(e) > 0,
                );
                if (sourceEntity) {
                  return getEntityExtractSuccess(sourceEntity);
                }

                // Last fallback: use global extract from steps_by_phase
                const extractStep = stepsByPhase.extract || {};
                return extractStep.success_record_count || 0;
              };

              // Calculate progress per entity for a given phase (multiple entities)
              const calculateEntityPhaseProgress = (
                phase,
                entity,
                entityIndex,
              ) => {
                const phaseStep = entity[phase] || {};
                const entityExtractTotal = getEntityExtractTotal(entity);

                const phaseSuccessCount = phaseStep.success_record_count || 0;

                // Track per-entity progress using entity name or index
                const entityKey = entity.entity || `entity_${entityIndex}`;
                const phaseKey = `${entityKey}_${phase}`;

                if (phase === 'extract') {
                  // For extract: show progress immediately when data exists
                  // Track max to only show increases
                  const stepStatus = phaseStep.step_status?.toUpperCase() || '';
                  const previousCount = previousCounts[phaseKey] || 0;
                  const currentCount = phaseSuccessCount;
                  const maxCount = Math.max(currentCount, previousCount);
                  previousCounts[phaseKey] = maxCount;

                  // Track the maximum extract total seen
                  const totalKey = `${entityKey}_extract_total`;
                  const previousTotal = previousCounts[totalKey] || 0;
                  const currentTotal = entityExtractTotal;
                  const maxTotal = Math.max(currentTotal, previousTotal);
                  previousCounts[totalKey] = maxTotal;

                  // Progress = (extracted records / total records) * 100
                  // Show immediately when extract has data
                  if (maxTotal > 0) {
                    // If step is SUCCESS, show 100%
                    if (stepStatus === 'SUCCESS') {
                      return 100;
                    }
                    // Otherwise, calculate based on success count
                    const progress = Math.min((maxCount / maxTotal) * 100, 100);
                    return progress;
                  }

                  // If extract just started (has success but no total yet)
                  if (maxCount > 0) {
                    return 10; // Show 10% when extract starts
                  }

                  return 0;
                } else {
                  // For transform/load: progress based on success count only
                  // Compare against extract success_record_count (not total) for accurate progress
                  const stepStatus = phaseStep.step_status?.toUpperCase() || '';
                  let entityExtractSuccess = getEntityExtractSuccess(entity);

                  // Handle decision workflows: if entity has no extract but has load data,
                  // use decision routing or source extract as baseline
                  if (entityExtractSuccess === 0 && phaseSuccessCount > 0) {
                    entityExtractSuccess = getEntityBaselineForDecision(
                      entity,
                      phase,
                    );
                  }

                  const successKey = `${entityKey}_${phase}_success`;
                  const previousSuccess = previousCounts[successKey] || 0;
                  const maxSuccess = Math.max(
                    phaseSuccessCount,
                    previousSuccess,
                  );
                  previousCounts[successKey] = maxSuccess;

                  // Progress is based on how much of the successfully extracted data has been processed
                  if (entityExtractSuccess > 0) {
                    // If step is SUCCESS, verify counts match before showing 100%
                    if (stepStatus === 'SUCCESS') {
                      // Only show 100% if success count matches or exceeds baseline
                      if (maxSuccess >= entityExtractSuccess) {
                        return 100;
                      }
                      // If SUCCESS but counts don't match yet, calculate based on actual progress
                      return Math.min(
                        (maxSuccess / entityExtractSuccess) * 100,
                        100,
                      );
                    }
                    // Otherwise, calculate based on success count only
                    return Math.min(
                      (maxSuccess / entityExtractSuccess) * 100,
                      100,
                    );
                  }
                  return 0;
                }
              };

              // Calculate average progress across all entities for a phase
              const calculateMultiEntityProgress = (phase) => {
                // Get extract total from steps_by_phase as fallback
                const extractStep = stepsByPhase.extract || {};
                const globalExtractTotal =
                  (extractStep.success_record_count || 0) +
                  (extractStep.failure_record_count || 0);
                console.log('globalExtractTotal', globalExtractTotal);

                // Calculate progress for each entity
                const entityProgresses = stepsByEntity.map((entity, index) => {
                  const entityProgress = calculateEntityPhaseProgress(
                    phase,
                    entity,
                    index,
                  );

                  // If entity progress is 0, check if entity has extract data
                  // For transform/load, we need extract success count to calculate progress
                  if (entityProgress === 0 && phase !== 'extract') {
                    const phaseStep = entity[phase] || {};
                    const phaseSuccess = phaseStep.success_record_count || 0;

                    // Skip if no phase data
                    if (phaseSuccess === 0) {
                      return 0;
                    }

                    // Try to get baseline: first from entity extract, then from decision routing
                    let baseline = getEntityExtractSuccess(entity);

                    // If no extract data, use decision workflow baseline
                    if (baseline === 0) {
                      baseline = getEntityBaselineForDecision(entity, phase);
                    }

                    // If we have a baseline, calculate progress
                    if (baseline > 0) {
                      const stepStatus =
                        phaseStep.step_status?.toUpperCase() || '';

                      if (stepStatus === 'SUCCESS') {
                        // Only show 100% if success count matches or exceeds baseline
                        if (phaseSuccess >= baseline) {
                          return 100;
                        }
                        // If SUCCESS but counts don't match yet, calculate based on actual progress
                        return Math.min((phaseSuccess / baseline) * 100, 100);
                      }
                      // Calculate progress based on baseline
                      return Math.min((phaseSuccess / baseline) * 100, 100);
                    }
                  }

                  return entityProgress;
                });

                // Average progress across all entities
                if (entityProgresses.length === 0) return 0;

                // For decision workflows with load phase: calculate total loaded vs total extracted
                // This ensures 100% when all extracted records are loaded, regardless of distribution
                if (phase === 'load') {
                  // Check if this is a decision workflow:
                  // - Some entities have no extract but have load data (destination entities)
                  // - At least one entity has extract data (source entity)
                  const hasSourceEntity = stepsByEntity.some(
                    (e) => getEntityExtractSuccess(e) > 0,
                  );
                  const hasDestinationEntities = stepsByEntity.some(
                    (e) =>
                      getEntityExtractSuccess(e) === 0 &&
                      (e.load || {}).success_record_count > 0,
                  );

                  if (hasSourceEntity && hasDestinationEntities) {
                    // This is a decision workflow - calculate total loaded vs total extracted
                    const totalLoaded = stepsByEntity.reduce((sum, entity) => {
                      const loadStep = entity.load || {};
                      return sum + (loadStep.success_record_count || 0);
                    }, 0);

                    // Get total extracted from source entity or steps_by_phase
                    const sourceEntity = stepsByEntity.find(
                      (e) => getEntityExtractSuccess(e) > 0,
                    );
                    const totalExtracted = sourceEntity
                      ? getEntityExtractSuccess(sourceEntity)
                      : (stepsByPhase.extract || {}).success_record_count || 0;

                    if (totalExtracted > 0) {
                      const progress = Math.min(
                        (totalLoaded / totalExtracted) * 100,
                        100,
                      );
                      return progress;
                    }
                  }
                }

                // Check for entities that haven't started this phase yet (sequential processing case)
                const entitiesNotStarted = stepsByEntity.filter((entity) => {
                  const phaseStep = entity[phase] || {};
                  const stepStatus = phaseStep.step_status?.toUpperCase() || '';
                  // Entity hasn't started if no status or status is UNKNOWN
                  return stepStatus === '' || stepStatus === 'UNKNOWN';
                }).length;

                // Verify all entities have completed before showing 100%
                // Check that each entity's phase success count >= its baseline (extract or decision routing)
                const allEntitiesComplete = stepsByEntity.every((entity) => {
                  if (phase === 'extract') {
                    const extractStep = entity.extract || {};
                    const stepStatus =
                      extractStep.step_status?.toUpperCase() || '';
                    return stepStatus === 'SUCCESS';
                  } else {
                    const phaseStep = entity[phase] || {};
                    const phaseSuccess = phaseStep.success_record_count || 0;
                    const stepStatus =
                      phaseStep.step_status?.toUpperCase() || '';

                    // Get baseline: first try entity extract, then decision routing
                    let baseline = getEntityExtractSuccess(entity);

                    // If no extract data, use decision workflow baseline
                    if (baseline === 0) {
                      baseline = getEntityBaselineForDecision(entity, phase);
                    }

                    // If no baseline available, can't determine completion
                    if (baseline === 0) {
                      return false;
                    }

                    // Entity is complete if status is SUCCESS AND success count >= baseline
                    return stepStatus === 'SUCCESS' && phaseSuccess >= baseline;
                  }
                });

                const avgProgress =
                  entityProgresses.reduce((sum, p) => sum + p, 0) /
                  entityProgresses.length;

                // Only return 100% if all entities are complete, otherwise return average
                if (allEntitiesComplete && avgProgress >= 100) {
                  return 100;
                }

                // For sequential processing: if some entities haven't started, cap progress
                // This prevents showing 100% when first entity completes but second hasn't started
                if (entitiesNotStarted > 0) {
                  // Calculate progress based on entities that have started
                  const entitiesStarted =
                    stepsByEntity.length - entitiesNotStarted;
                  // Cap progress: (entities started / total entities) * 100
                  // This ensures progress doesn't exceed the proportion of entities that have started
                  const maxProgressForStartedEntities =
                    (entitiesStarted / stepsByEntity.length) * 100;
                  // Use the minimum of average progress and max allowed progress
                  return Math.min(avgProgress, maxProgressForStartedEntities);
                }

                return Math.min(avgProgress, 100);
              };

              // Main progress calculation - choose based on single vs multiple entities
              // For decision and backtrack, always prefer steps_by_phase if available (aggregated view)
              const calculatePhaseProgress = (phase) => {
                const phaseStepInPhase = stepsByPhase[phase];

                // Always use steps_by_phase for decision and backtrack phases when available
                // These phases can have inconsistent entity data
                if (
                  phaseStepInPhase &&
                  (phase === 'decision' || phase === 'backtrack')
                ) {
                  const stepStatus =
                    phaseStepInPhase.step_status?.toUpperCase() || '';
                  const phaseSuccess =
                    phaseStepInPhase.success_record_count || 0;

                  // Get extract total from steps_by_phase
                  const extractStep = stepsByPhase.extract || {};
                  const extractTotal =
                    (extractStep.success_record_count || 0) +
                    (extractStep.failure_record_count || 0);

                  if (stepStatus === 'SUCCESS') {
                    // Only show 100% if success count matches or exceeds extract total
                    if (extractTotal > 0 && phaseSuccess >= extractTotal) {
                      return 100;
                    }
                    // If SUCCESS but counts don't match yet, calculate based on actual progress
                    if (extractTotal > 0) {
                      return Math.min((phaseSuccess / extractTotal) * 100, 100);
                    }
                    // If no extract total yet, return 100% if status is SUCCESS (assume complete)
                    return 100;
                  }

                  if (extractTotal > 0) {
                    return Math.min((phaseSuccess / extractTotal) * 100, 100);
                  }

                  // If extract not available yet, show progress based on success count
                  if (phaseSuccess > 0) {
                    return 10; // Show 10% when started
                  }

                  return 0;
                }

                // For other phases, use normal calculation
                if (isSingleEntity) {
                  // Single entity: use steps_by_phase
                  return calculateSingleEntityProgress(phase);
                } else {
                  // Multiple entities: always check each entity individually
                  // Don't rely on steps_by_phase as it may have incorrect aggregated values
                  // Calculate progress by checking all entities in steps_by_entity
                  return calculateMultiEntityProgress(phase);
                }
              };

              // Get total counts for display
              const getPhaseTotalCounts = (phase) => {
                if (!isSingleEntity && hasEntityData) {
                  const totalSuccess = stepsByEntity.reduce((sum, entity) => {
                    const phaseStep = entity[phase] || {};
                    return sum + (phaseStep.success_record_count || 0);
                  }, 0);
                  const totalFailure = stepsByEntity.reduce((sum, entity) => {
                    const phaseStep = entity[phase] || {};
                    return sum + (phaseStep.failure_record_count || 0);
                  }, 0);
                  return { success: totalSuccess, failure: totalFailure };
                }

                const phaseStep = stepsByPhase[phase] || {};
                return {
                  success: phaseStep.success_record_count || 0,
                  failure: phaseStep.failure_record_count || 0,
                };
              };

              // Calculate percentage for each phase - show immediately without delay
              const phaseData = orderedPhases
                .filter((phase) => {
                  // Include phase if it exists in steps_by_phase (preferred) or steps_by_entity
                  // Always check steps_by_phase first for decision and backtrack
                  if (stepsByPhase[phase]) {
                    return true;
                  }
                  if (isSingleEntity) {
                    return false;
                  }
                  // For multiple entities, check if any entity has this phase
                  return stepsByEntity.some((e) => e[phase]);
                })
                .map((phase) => {
                  // Calculate current progress - show immediately
                  const currentProgress = calculatePhaseProgress(phase);

                  // Track previous progress to prevent going backwards, but show current immediately
                  const previousProgress =
                    previousCounts[`phase_${phase}`] || 0;
                  const progress = Math.max(currentProgress, previousProgress);

                  // Update previous progress
                  previousCounts[`phase_${phase}`] = progress;

                  const step = stepsByPhase[phase] || {};
                  const counts = getPhaseTotalCounts(phase);
                  const totalCount = counts.success + counts.failure;

                  // Get step status - prefer steps_by_phase, especially for decision/backtrack
                  let stepStatus = step.step_status || 'UNKNOWN';
                  // For decision and backtrack, always use steps_by_phase if available
                  if (
                    (phase === 'decision' || phase === 'backtrack') &&
                    step.step_status
                  ) {
                    stepStatus = step.step_status;
                  } else if (!isSingleEntity && hasEntityData) {
                    // For other phases, check entity data if steps_by_phase doesn't have status
                    if (!step.step_status) {
                      for (const entity of stepsByEntity) {
                        const entityPhaseStep = entity[phase];
                        if (entityPhaseStep && entityPhaseStep.step_status) {
                          stepStatus = entityPhaseStep.step_status;
                          break;
                        }
                      }
                    }
                  }

                  return {
                    phase,
                    count: counts.success,
                    totalCount,
                    percent: progress,
                    step,
                    stepStatus,
                  };
                });

              // Sort phaseData by orderedPhases to ensure correct order (extract first)
              const sortedPhaseData = [...phaseData].sort((a, b) => {
                const indexA = orderedPhases.indexOf(a.phase);
                const indexB = orderedPhases.indexOf(b.phase);
                return indexA - indexB;
              });

              // Calculate flexible weights based on available phases
              // Each phase gets equal weight, so they sum to 100%
              const totalPhases = sortedPhaseData.length;
              const weightPerPhase = totalPhases > 0 ? 100 / totalPhases : 0;

              // Calculate cumulative progress: extract fills first, then transform, etc.
              // Each phase contributes its percentage * its weight
              let cumulativeProgress = 0;
              const phaseSegments = sortedPhaseData.map((phaseDataItem) => {
                const phase = phaseDataItem.phase;
                const phaseProgress = phaseDataItem.percent;
                // Each phase contributes (phaseProgress / 100) * weightPerPhase
                const segmentProgress = (phaseProgress / 100) * weightPerPhase;
                const segmentStart = cumulativeProgress;
                cumulativeProgress += segmentProgress;
                return {
                  phase,
                  progress: phaseProgress,
                  segmentStart,
                  segmentEnd: cumulativeProgress,
                  segmentWidth: segmentProgress,
                  phaseDataItem, // Keep reference to original data
                };
              });

              // Overall progress is the sum of all phase contributions
              // When all phases are 100%, overall will be 100%
              let overallProgress = Math.min(cumulativeProgress, 100);

              // If all phases are 100%, ensure overall is exactly 100%
              const allPhasesComplete = sortedPhaseData.every(
                (p) => p.percent >= 100,
              );
              if (allPhasesComplete && sortedPhaseData.length > 0) {
                overallProgress = 100;
              }

              // Determine progress bar color based on workflow status
              const getProgressBarColor = () => {
                if (workflowStatus === 'FAILED') {
                  return 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)'; // Red
                }
                if (workflowStatus === 'PARTIAL_SUCCESS') {
                  return 'linear-gradient(90deg, #ff9800 0%, #ffb74d 100%)'; // Orange
                }
                return 'linear-gradient(90deg, #5965A6 0%, #7B84C1 100%)'; // Default blue
              };

              // Find failed step
              const findFailedStep = () => {
                // Check steps_by_phase
                for (const phase of orderedPhases) {
                  const step = stepsByPhase[phase];
                  if (step && step.step_status === 'FAILED') {
                    return { phase, stepName: step.step_name, source: 'phase' };
                  }
                }
                // Check steps_by_entity
                for (const entity of stepsByEntity) {
                  for (const phase of orderedPhases) {
                    const step = entity[phase];
                    if (step && step.step_status === 'FAILED') {
                      return {
                        phase,
                        stepName: step.step_name,
                        entity: entity.entity,
                        source: 'entity',
                      };
                    }
                  }
                }
                return null;
              };

              const failedStep = findFailedStep();

              // Helper to format phase name
              const formatPhaseName = (phase) => {
                return phase.charAt(0).toUpperCase() + phase.slice(1);
              };

              return (
                <Box
                  sx={{
                    mt: 2,
                    mb: 2,
                    p: 2,
                    borderRadius: '8px',
                    background: darkMode
                      ? 'rgba(89, 101, 166, 0.1)'
                      : 'rgba(89, 101, 166, 0.05)',
                    border: `1px solid ${darkMode ? 'rgba(89, 101, 166, 0.3)' : 'rgba(89, 101, 166, 0.2)'}`,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 1.5,
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: '0.875rem',
                          fontWeight: 600,
                          color: darkMode ? '#E2E8F0' : '#1e293b',
                        }}
                      >
                        Overall Progress
                      </Typography>
                      {failedStep && (
                        <Typography
                          sx={{
                            fontSize: '0.75rem',
                            color: '#d32f2f',
                            mt: 0.5,
                            fontWeight: 500,
                          }}
                        >
                          Failed: {failedStep.stepName}
                          {failedStep.entity && ` (${failedStep.entity})`}
                        </Typography>
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        color:
                          workflowStatus === 'FAILED'
                            ? '#d32f2f'
                            : workflowStatus === 'PARTIAL_SUCCESS'
                              ? '#ff9800'
                              : '#5965A6',
                      }}
                    >
                      {overallProgress.toFixed(1)}%
                    </Typography>
                  </Box>

                  <Tooltip
                    title={
                      <Box sx={{ p: 1 }}>
                        <Typography
                          variant="caption"
                          sx={{
                            display: 'block',
                            mb: 1,
                            fontWeight: 600,
                            fontSize: '0.8rem',
                          }}
                        >
                          Workflow Progress Details
                        </Typography>
                        <Box
                          sx={{
                            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                            pt: 1,
                            mt: 1,
                          }}
                        >
                          {sortedPhaseData.map((phase, index) => {
                            const phaseStatus =
                              phase.stepStatus?.toUpperCase() || '';
                            return (
                              <Typography
                                key={phase.phase}
                                variant="caption"
                                sx={{
                                  display: 'block',
                                  mb:
                                    index < sortedPhaseData.length - 1
                                      ? 0.75
                                      : 0,
                                  color:
                                    phaseStatus === 'FAILED'
                                      ? '#f44336'
                                      : phaseStatus === 'PARTIAL_SUCCESS'
                                        ? '#ff9800'
                                        : 'inherit',
                                }}
                              >
                                <strong>{formatPhaseName(phase.phase)}:</strong>{' '}
                                {phase.count.toLocaleString()} success records
                                {phase.totalCount > phase.count && (
                                  <span style={{ opacity: 0.7 }}>
                                    {' '}
                                    / {phase.totalCount.toLocaleString()} total
                                  </span>
                                )}
                                {phaseStatus && (
                                  <span
                                    style={{
                                      marginLeft: '8px',
                                      fontSize: '0.7rem',
                                      opacity: 0.9,
                                    }}
                                  >
                                    ({phaseStatus})
                                  </span>
                                )}
                                <br />
                                <span style={{ opacity: 0.8 }}>
                                  {phase.phase === 'extract'
                                    ? `${phase.percent.toFixed(1)}% complete (baseline)`
                                    : `${phase.percent.toFixed(1)}% of extracted records`}
                                </span>
                              </Typography>
                            );
                          })}
                        </Box>
                        <Box
                          sx={{
                            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                            pt: 1,
                            mt: 1,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ fontSize: '0.75rem', opacity: 0.9 }}
                          >
                            <strong>Overall Progress:</strong>{' '}
                            {overallProgress.toFixed(1)}%
                          </Typography>
                          {failedStep && (
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: '0.75rem',
                                color: '#f44336',
                                display: 'block',
                                mt: 0.5,
                                fontWeight: 600,
                              }}
                            >
                              <strong>Failed Step:</strong>{' '}
                              {failedStep.stepName}
                              {failedStep.entity &&
                                ` (Entity: ${failedStep.entity})`}
                            </Typography>
                          )}
                          {workflowStatus && (
                            <Typography
                              variant="caption"
                              sx={{
                                fontSize: '0.75rem',
                                display: 'block',
                                mt: 0.5,
                                color:
                                  workflowStatus === 'FAILED'
                                    ? '#f44336'
                                    : workflowStatus === 'PARTIAL_SUCCESS'
                                      ? '#ff9800'
                                      : '#4caf50',
                              }}
                            >
                              <strong>Status:</strong> {workflowStatus}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    }
                    arrow
                    placement="top"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'rgba(30, 41, 59, 0.95)',
                          backdropFilter: 'blur(8px)',
                          border: '1px solid rgba(89, 101, 166, 0.3)',
                          maxWidth: 280,
                        },
                      },
                      arrow: {
                        sx: {
                          color: 'rgba(30, 41, 59, 0.95)',
                        },
                      },
                    }}
                  >
                    <Box
                      sx={{
                        position: 'relative',
                        width: '100%',
                        height: 8,
                        borderRadius: '4px',
                        overflow: 'hidden',
                        background: darkMode
                          ? 'rgba(156, 163, 175, 0.3)'
                          : 'rgba(209, 213, 219, 0.8)',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          boxShadow: `0 2px 8px rgba(89, 101, 166, 0.25)`,
                        },
                      }}
                    >
                      {/* Segmented Progress Bar - Extract first, then Transform, then Load, etc. */}
                      {phaseSegments.map((segment, index) => {
                        if (segment.segmentWidth <= 0) return null;

                        // Use the same color for all segments based on workflow status
                        // Purple by default, red for failed, orange for partial success
                        const segmentColor = getProgressBarColor();

                        return (
                          <Box
                            key={segment.phase}
                            sx={{
                              position: 'absolute',
                              left: `${segment.segmentStart}%`,
                              top: 0,
                              width: `${segment.segmentWidth}%`,
                              height: '100%',
                              background: segmentColor,
                              transition: 'width 0.5s ease, left 0.5s ease',
                              boxShadow:
                                'inset 0 1px 2px rgba(255, 255, 255, 0.2)',
                              zIndex: phaseSegments.length - index, // Later phases on top
                            }}
                          />
                        );
                      })}
                    </Box>
                  </Tooltip>

                  {/* Stage Progress Details */}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      mt: 1.5,
                      gap: 1,
                    }}
                  >
                    {sortedPhaseData.map((phase) => {
                      const phaseStatus = phase.stepStatus?.toUpperCase() || '';
                      const getPhaseColor = () => {
                        if (phaseStatus === 'FAILED') return '#d32f2f';
                        if (phaseStatus === 'PARTIAL_SUCCESS') return '#ff9800';
                        return '#5965A6';
                      };
                      return (
                        <Box
                          key={phase.phase}
                          sx={{ flex: 1, textAlign: 'center' }}
                        >
                          <Typography
                            sx={{
                              fontSize: '0.75rem',
                              color: darkMode
                                ? 'rgba(226, 232, 240, 0.7)'
                                : 'rgba(30, 41, 59, 0.7)',
                            }}
                          >
                            {formatPhaseName(phase.phase)}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '0.875rem',
                              fontWeight: 600,
                              color: getPhaseColor(),
                            }}
                          >
                            {phase.percent.toFixed(1)}%
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              );
            })()}

          <RunStatusTables runStatus={runStatus} showPhase />
          {scheduledStatus?.status && (
            <ScheduledStatusTable scheduledStatus={scheduledStatus} />
          )}

          {/* Error Message */}

          {runStatus?.status &&
            ((runStatus?.steps_by_phase &&
              Object.keys(runStatus.steps_by_phase).length > 0) ||
              (Array.isArray(runStatus?.steps_by_entity) &&
                runStatus.steps_by_entity.length > 0)) && (
              <StatusTable
                runStatus={runStatus}
                logsDialogOpen={() => setLogsDialogOpen(true)}
              />
            )}
        </Paper>
      </Box>

      {/* Logs Dialog */}
      <LogsViewer
        open={logsDialogOpen}
        onClose={() => setLogsDialogOpen(false)}
        workflowRunId={workflowRunId}
      />

      <SimpleLogsViewer
        open={simpleLogsDialogOpen}
        onClose={() => setSimpleLogsDialogOpen(false)}
        workflowRunId={workflowRunId}
        runStatus={runStatus}
      />
    </>
  );
}

ActionButtonsInner.propTypes = {
  selectedNode: PropTypes.shape({
    id: PropTypes.string,
  }),
  workflowId: PropTypes.string,
  workflowConfigurationId: PropTypes.string,
  // workflowName: PropTypes.string,
  onWorkflowExecutionComplete: PropTypes.func,
  onSave: PropTypes.func,
  onCollapsedChange: PropTypes.func,
  collapsedBoth: PropTypes.bool,
  leftSidebarRef: PropTypes.any,
  rightSidebarRef: PropTypes.any,
};

const ActionButtons = forwardRef(ActionButtonsInner);
export default ActionButtons;
